export default "/images/7b4f0c74b176661e9185afabf8d0baf4.jpg";